import {
  Package,
  CloudUpload,
  Target,
  MapPinHouse,
  Check,
} from "lucide-react";

export const steps = [
  {
    id: 1,
    title: "Offer Setup",
    subtitle: "Setup Deal details",
    icon: Package,
  },
  {
    id: 2,
    title: "Supporting Details",
    subtitle: "Additional Details",
    icon: CloudUpload,
  },
  {
    id: 3,
    title: "Targeting Criteria",
    subtitle: "Narrow down Audience",
    icon: Target,
  },
  {
    id: 4,
    title: "Redemption Details",
    subtitle: "Deal Redemption Info",
    icon: MapPinHouse,
  },
  {
    id: 5,
    title: "Review & Submit",
    subtitle: "Review your deal",
    icon: Check,
  },
];
